import { useCallback, useState } from "react";
import { isReadingModeEnabled, setReadingModeValue } from "../utils/readingMode";

export const useReadingMode = () => {
  const [enabled, setEnabledState] = useState(isReadingModeEnabled);

  const setEnabled = useCallback((value) => {
    setReadingModeValue(value);
    setEnabledState(value);
  }, []);

  return [enabled, setEnabled];
};